//REVIEW AND COMPLETE SECTION COPY
export const SECTION_TITLE = 'Review and Complete';
export const BOOKING_CONSENT =
  "By selecting the “Agree and Book” button, I confirm I have read and agree to Great Wolf Lodge's <TERMS> <POLICY> Property Rules & Restrictions, and the Cancellation and Refund Policy for the rate I am booking, and I am at least 21 years old. By providing a mobile phone number, I expressly consent to receiving informational SMS texts and calls related to my booking and/or stay.";
export const TERMS = 'Terms and Conditions,';
export const TERMS_CLEAN = 'Terms';
export const POLICY = 'Privacy Policy';
export const TOTAL = 'Total';
export const DUE_TODAY = 'Due today';
export const DUE_CHECKIN = 'Due at Check-In';
export const REFER_OR_CONTACT = `Please refer to our <POLICY> or <CONTACT> for more details.`;
export const ARIA_MAILING = 'Allow to receive Great Wolf emails';
export const ARIA_SIGNATURE = 'Electronic signature compliance';

//RENDER PAYMENT BUTTON COPY
export const AGREE_AND_BOOK = 'Agree & Book';

//ERROR ALERT COPY
export const ERROR = 'Something went wrong with your payment.';
export const ERROR_DESCRIPTION =
  'Sorry but there was a problem using <PAYMENT_METHOD>. Please try again or use “edit” to select a different payment option.';

//FLEX FARE COPY
export const UPDATE_TO_FLEXIBLE_RATE = 'Upgrade to a Flexible Rate (Highly Recommended)';
export const YES_TO_FLEXIBLE_RATE =
  '<strong key="yes">Yes, upgrade my stay to a Flexible Rate.</strong> <br> Change or cancel for a full refund any time up until check‑in if plans change.';
export const ARIA_HEADER = 'Add flexibility to your trip';
export const ARIA_CHECKBOX = 'Allow ability to cancel reservation';

export const ACCEPT_VISA = 'We accept Visa';
export const ACCEPT_MASTER = 'We accept MasterCard';
export const ACCEPT_AMERICAN = 'We accept American Express';
export const ACCEPT_DISCOVER = 'We accept Discover';
export const CREDIT_CARD_CONTINUE_BUTTON = 'Continue';
export const CREDIT_CARD_INFO = 'Credit Card Info';
export const FORM_NAME_ON_CARD = 'Name on card';
export const FORM_CARD_NUMBER = 'Card Number';
export const FORM_MONTH = 'Month';
export const FORM_YEAR = 'Year';
export const FORM_CVV = 'CVV';
export const FORM_CVV_ALT = '3 digit security code on back of credit card';
export const FORM_CARD_HOLDER = 'Card holder not present at check-in?';
export const FORM_DONT_WORRY = "Don't Worry!";
export const FORM_WARN_FORM_ONLINE =
  'If the Card Holder will not be at check-in, complete the credit card authorization form online.';
export const FORM_COMPLETE_ONLINE_PROCESS = 'Complete Online process';
export const FORM_BACK_PAYMENT = 'Back to payment';

//PAYMENT FROM HELPER COPY
export const QUALIFYING_ID = 'Qualifying ID: <ID>';
export const GREAT_WOLF_LODGE = 'Great Wolf Lodge';
export const US = 'US';
export const SELECT_PAYMENT_METHOD = 'Payment & Billing';

// AFFIRM TEXTS
export const AFFIRM_NO_LATE_FEES = `No late fees, hidden insterest, or surprises. Ever. Get a real-time decision without affecting your credit score.`;
export const AFFIRM_AFTER_CHECKING = `After clicking `;
export const AFFIRM_CONTINUE = `"Continue"`;
export const AFFIRM_MESSAGE = `, you will be redirected to Affirm to securely complete your purchase. Just fill out a few pieces of basic information, and get a real-time decision without affecting your credit score.`;
export const AFFIRM_ADITIONAL = `* Affirm Monthly Payments cannot be combined with gift cards or eGift certificates.`;
export const AFFIRM_CONTINUE_BUTON = `Continue with <ICON>`;
export const AFFIRM_EDIT_BUTON = `Save changes with <ICON>`;
export const SAVE_CHANGES_BUTTON = `Save changes`;
export const AFFIRM_CHECKOUT_BUTTON = `Check out with <ICON>`;

// BILLING INFORMATION
export const BILLING_INFORMATION = `Billing Info`;
export const USE_SAME_BILLING_ADDRESS = `Use the same address I used for my booking`;
export const ADDRESS_LINE_2 = `+ Add Address Line 2 (optional)`;

// INDEX
export const CONTACT_INFO = 'Contact Info';
export const MONTHLY_PAYMENTS = 'Monthly payments';
export const PAYMENTS_OPTIONS = 'Payment Options';
export const AFFIRM_PAYMENTS_OPTIONS = 'Affirm Monthly Payments not available to non-US residents.';
export const REVIEW_COMPLETE = 'Review & Complete';

//PaypalSuccessAlert
export const CONTINUE = "'continue'";

//Paypal.js
export const PAYPAL_CHANGE_OPTION_WARNING =
  "Heads up! If you change your payment option you'll need to start the PayPal process again.";
export const PAYPAL_AUTHORIZE_INSTRUCTIONS_START = 'Click on';
export const PAYPAL_AUTHORIZE_BUTTON_LABEL = '"Pay with PayPal"';
export const PAYPAL_AUTHORIZE_INSTRUCTIONS_END = 'below to securely authorize PayPal as your payment method.';

//GooglePay.js
export const BUTTON_WARNING = 'Continue on the popup window';

//AvailabilityAlert.js
export const GREAT_DEALS = "<strong>Don't miss out on this great deal!</strong> Act fast, this price might change!";

export const CHECKOUT_AS_GUEST = 'CHECKOUT AS GUEST';
//BIRTHDAY
export const PARTY_DETAILS = '<ADULTS> adults, <KIDS> kids, <INFANTS> infants, <SPECTATORS> spectators';

export const PAYMENT_HEADER_DISCLAIMER = 'All fields are required unless marked otherwise';

export const SIGN_IN = 'Log in';

export const googlePay = 'Google Pay';
export const applePay = 'Apple Pay';
export const affirm = 'Monthly Payments';
export const creditCard = 'Credit Card';
export const paypal = 'PayPal';
export const affirmLabel = 'Affirm';

export const CANCELLATION_POLICY = 'Cancellation Policy';
export const CONTACT_US = 'contact us';
export const CANCELLATION_TEXT_DEFAULT =
  'Free cancellation with full refund before 11:59 PM local hotel time on <DATE>. Non-refundable after <DATE2>';
export const CANCELLATION_TEXT_STANDARD = 'Non-refundable after <DATE>.';
export const CANCELLATION_TEXT_FLEXIBLE =
  'Risk Free Booking: Free cancellation with full refund before 4:00 PM local hotel time on <DATE>. Non-refundable after <DATE2>.';

export const USER_REQUIRED_ALERT = 'Rate for Voyagers Club members only. Log in or <JOIN>';
export const JOIN_UNLOCK = 'join to unlock.';
